import { render, staticRenderFns } from "./detection-update.vue?vue&type=template&id=0693db2e&"
import script from "./detection-update.vue?vue&type=script&lang=js&"
export * from "./detection-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports